import React from 'react';
export function GoldRule({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex items-center gap-3 sm:gap-5 my-10" data-id="element-223" data-mp="3hclfmjyi3d9i">
      <span className="flex-1 h-px bg-gold-ultra-light" data-id="element-224" data-mp="3hd4vzw8i5tlf" />
      <span className="font-serif italic text-base sm:text-lg text-gold tracking-[2px] sm:tracking-[3px] text-center leading-none px-3 py-1 border-y border-gold-ultra-light whitespace-nowrap" data-id="element-225" data-mp="3d9yu10sfaokr">
        {children}
      </span>
      <span className="flex-1 h-px bg-gold-ultra-light" data-id="element-226" data-mp="33e59au4jvorw" />
    </div>;
}